import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IStackedProgress } from '@dxp/core/models';
import { NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';

/**
 * Component to display progress
 *
 * @selector stacked-progressbar
 * @standalone true
 * @component ProgressComponent
 * @imports CommonModule
 *
 * @Input states - Array of progress states.
 *
 * Usage:
 * <stacked-progressbar [states]="data"></stacked-progressbar>
 *
 */
@Component({
    selector: 'telxl-stacked-progressbar',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, NgbProgressbarModule],
    templateUrl: './stacked-progress.component.html',
    styleUrl: './stacked-progress.component.scss',
})
export class TelXLStackedProgressComponent {
    font = input.required<string>();
    weight = input.required<string>();
    showLabels = input<boolean>(false);
    states = input.required<IStackedProgress[]>();
}
